import React from 'react'
import { useDispatch } from 'react-redux'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { BaseCard } from '../base-card'

export function FaqCard() {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_FAQ)
    dispatch(setDrawer(DRAWER_KEY.FAQ))
  }

  function renderContent() {
    return <BaseCard onClick={handleClick} text='Giga+ Ajuda' icon={<STATICS.FAQ_CARD />} />
  }

  return renderContent()
}
